import * as React from 'react';
import { Image } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import useGetImage from './hooks/useGetIcon';
import APP_ICON from './images/app.png';

const ERROR_TEXT = 'error';

const styles: React.CSSProperties = {
  borderRadius: 5,
  width: 65,
  height: 65,
  objectFit: 'contain',
};

interface AppIconProps {
  id?: string;
  style?: Record<string, any>;
  width?: number;
}

const AppIcon = React.memo(({ id = undefined, style = undefined, width = 65 }: AppIconProps) => {
  const [image, status] = useGetImage(id);
  const size = width || 65;

  if (status === 'pending') {
    return <LoadingOutlined style={{ ...styles, ...style, width: size, height: size }} />;
  }
  return (
    <Image
      width={size}
      height={size}
      preview={false}
      style={{ ...styles, ...style, width: size, height: size }}
      src={!id || status === 'error' ? ERROR_TEXT : image}
      fallback={APP_ICON}
    />
  );
});

AppIcon.displayName = 'AppIcon';

export default AppIcon;
